export const DOCUMENTS_PAGE_MAIN_TAB_KEY = 'documents-page-main-tab';

export type DocumentsPageMainTab = 'registry' | 'applications';

export function readDocumentsPageMainTab(): DocumentsPageMainTab {
  try {
    return localStorage.getItem(DOCUMENTS_PAGE_MAIN_TAB_KEY) === 'applications' ? 'applications' : 'registry';
  } catch {
    return 'registry';
  }
}

export function writeDocumentsPageMainTab(tab: DocumentsPageMainTab): void {
  try {
    localStorage.setItem(DOCUMENTS_PAGE_MAIN_TAB_KEY, tab);
  } catch {
    // ignore
  }
}

export function shouldFetchDocumentRegistry(hasSearched: boolean): boolean {
  return hasSearched;
}

export function getRegistryEmptyDescription(hasSearched: boolean, total: number): string {
  if (!hasSearched) return 'Укажите параметры поиска';
  if (total === 0) return 'Документы не найдены';
  return '';
}

export const DOCUMENT_REGISTRY_CATEGORY_OPTIONS = [
  { value: 'loading_photo', label: 'Фото погрузки' },
  { value: 'unloading_photo', label: 'Фото выгрузки' },
  { value: 'loading_docs', label: 'Документы погрузки' },
  { value: 'unloading_docs', label: 'Документы выгрузки' },
  { value: 'tn', label: 'ТН' },
  { value: 'carrier_contract', label: 'Договор-заявка перевозчика' },
  { value: 'carrier_invoice', label: 'Счёт перевозчика' },
  { value: 'client_docs', label: 'Документы клиента' },
  { value: 'acts', label: 'Акты / УПД' },
  { value: 'originals', label: 'Оригиналы' },
  { value: 'other', label: 'Прочее' },
] as const;

export type DocumentRegistryFilterDraft = {
  applicationId?: number;
  internalNumber?: string;
  clientId?: number;
  carrierId?: number;
  routeId?: number;
  documentCategory?: string;
  dateFrom?: string;
  dateTo?: string;
  search?: string;
};

export function buildRegistrySearchParams(
  filters: DocumentRegistryFilterDraft,
  pagination: { page: number; limit: number; sortBy?: string; sortOrder?: string }
): Record<string, string | number> {
  return {
    page: pagination.page,
    limit: pagination.limit,
    sortBy: pagination.sortBy || 'createdAt',
    sortOrder: pagination.sortOrder || 'desc',
    ...(filters.applicationId != null ? { applicationId: filters.applicationId } : {}),
    ...(filters.internalNumber ? { internalNumber: filters.internalNumber } : {}),
    ...(filters.clientId != null ? { clientId: filters.clientId } : {}),
    ...(filters.carrierId != null ? { carrierId: filters.carrierId } : {}),
    ...(filters.routeId != null ? { routeId: filters.routeId } : {}),
    ...(filters.documentCategory ? { documentCategory: filters.documentCategory } : {}),
    ...(filters.dateFrom ? { dateFrom: filters.dateFrom } : {}),
    ...(filters.dateTo ? { dateTo: filters.dateTo } : {}),
    ...(filters.search?.trim() ? { search: filters.search.trim() } : {}),
  };
}

export function isRegistryFilterEmpty(filters: DocumentRegistryFilterDraft): boolean {
  return !(
    filters.applicationId != null ||
    filters.internalNumber?.trim() ||
    filters.clientId != null ||
    filters.carrierId != null ||
    filters.routeId != null ||
    filters.documentCategory ||
    filters.dateFrom ||
    filters.dateTo ||
    filters.search?.trim()
  );
}
